export const UserFAQdata = [
    {
        question: 'What can I find on Trybe?',
        answer: 'The Trybe app allows you to support your favorite fitness creators and have exclusive access to all of their training routines. Our workouts are easy to follow from your mobile phone. When you’re ready to train, pull out Trybe and it’ll guide you along a workout that has videos, timers, form cues, and more!',
    },
    {
        question: 'What is included in a subscription?',
        answer: 'Your Trybe subscription unlocks unlimited access to premium content from creators you choose to support. While many of our creators offer some free content on their Trybe app, you’ll only be able to access all of their workouts and programming by purchasing a premium subscription.',
    },
    {
        question: 'How much does a subscription cost?',
        answer: 'A Trybe subscription costs typically between $9.99-$19.99 USD per month, with discounts for 6 month and 1 year subscriptions. This will depend on which creator you choose to support!',
    },
    {
        question: 'Which devices are compatible with Trybe?',
        answer: 'You can access the Trybe app on all iOS and Android mobile devices.',         
    },
    {
        question: 'Can I support multiple creators?',
        answer: 'As a Trybe app subscriber, you get immediate access to the content for the creator you downloaded the app for. If you would like to support multiple creators, you can access their app only through each creator’s unique link and purchase an additional subscription to their content.',
    },
    {
        question: 'How can I switch between multiple creators on the app?',
        answer: 'Each creator has a dedicated space for their content on the Trybe app. If you choose to support more than one creator, you can switch between their content by going into “Settings” and clicking on “Switch Coach.', 
    },
    {
        question: 'How can I get a refund?',
        answer: 'If you aren’t satisfied with your experience on the Trybe app within 7 days of downloading the app, please reach out to us at support@trybe.do to request a refund. \n\n\nWe’re always open to feedback! Please let us know how we can improve Trybe and your reasons for leaving! We’re sorry to see you go—thanks for supporting our creators!',
        link: 'mailto:support@trybe.do',
        wordIndex: 25
    },
    {
        question: 'How do I delete my account?',
        answer: 'Please email support@trybe.do if you would like to have your account deleted. We typically respond within 2-3 days.',
        link: 'mailto:support@trybe.do',
        wordIndex: 3 
    },
    {
        question: 'Still have questions? Want to recommend a creator for the app? Have any feedback for us?',
        answer: 'Email us at support@trybe.do We love hearing from our users, feel free to reach out!',
        link: 'mailto:support@trybe.do',
        wordIndex: 4
    }  

]


// WEBPACK FOOTER //
// ./src/components/pages/tempUserFAQdata.js